import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authService } from '../../services/auth';
import LanguageSelector from '../Common/LanguageSelector';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (authService.isAuthenticated()) {
      navigate('/admin');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.login(username, password);
      navigate('/admin');
    } catch (err) {
      setError(err.message || t('auth.invalidCredentials') || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        {/* Header */}
        <div className="login-header">
          <div className="login-icon">
            <i className="fas fa-shield-alt"></i>
          </div>
          <h1>{t('auth.title') || 'Admin Login'}</h1>
          <p>{t('portal.title') || 'Bihar Election 2025'}</p>
        </div>

        {/* Body */}
        <div className="login-body">
          {/* Language Selector */}
          <div className="language-selector-wrapper">
            <LanguageSelector />
          </div>

          {/* Default Credentials Info */}
          {/* <div className="credentials-info">
            <strong>{t('auth.defaultCredentials') || 'Default Login'}:</strong>
            <div className="credentials-details">
              <div>
                <span>Username:</span> <code>admin</code>
              </div>
              <div>
                <span>Password:</span> <code>Admin@123</code>
              </div>
            </div>
          </div> */}

          {/* Error Message */}
          {error && (
            <div className="error-message">
              <i className="fas fa-exclamation-circle"></i>
              <span>{error}</span>
            </div>
          )}

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="login-form">
            {/* Username */}
            <div className="form-group">
              <label htmlFor="username">
                {t('auth.username') || 'Username'}
              </label>
              <div className="input-wrapper">
                {/* <i className="fas fa-user input-icon"></i> */}
                <input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder={t('auth.username') || 'Username'}
                  required
                  autoComplete="username"
                  className="form-input"
                />
              </div>
            </div>

            {/* Password */}
            <div className="form-group">
              <label htmlFor="password">
                {t('auth.password') || 'Password'}
              </label>
              <div className="input-wrapper">
                {/* <i className="fas fa-lock input-icon"></i> */}
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder={t('auth.password') || 'Password'}
                  required
                  autoComplete="current-password"
                  className="form-input"
                />
                <i
                  className={`fas fa-eye${showPassword ? '-slash' : ''} password-toggle`}
                  onClick={() => setShowPassword(!showPassword)}
                  role="button"
                  tabIndex={0}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                  onKeyPress={(e) => e.key === 'Enter' && setShowPassword(!showPassword)}
                ></i>
              </div>
            </div>

            {/* Remember Me */}
            <div className="remember-me">
              <input
                type="checkbox"
                id="rememberMe"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <label htmlFor="rememberMe">
                {t('auth.rememberMe') || 'Remember me for 7 days'}
              </label>
            </div>

            {/* Login Button */}
            <button
              type="submit"
              disabled={loading}
              className={`login-button ${loading ? 'loading' : ''}`}
            >
              {loading ? (
                <>
                  <div className="spinner"></div>
                  {t('common.loading') || 'Loading...'}
                </>
              ) : (
                <>
                  <i className="fas fa-sign-in-alt"></i>
                  {t('auth.loginButton') || 'Login'}
                </>
              )}
            </button>
          </form>

          {/* Back Links */}
          <div className="login-footer-links">
            <button
              onClick={() => navigate('/')}
              className="back-button"
            >
              <i className="fas fa-arrow-left"></i> 
              {t('auth.backToPortal') || 'Back to Portal'}
            </button>
          </div>
        </div>

        {/* Footer */}
        {/* <div className="login-footer">
          <i className="fas fa-lock"></i> 
          {t('auth.secureLogin') || 'Secure Login'} | © 2025 {t('portal.title') || 'Bihar Election 2025'}
        </div> */}
      </div>
    </div>
  );
};

export default Login;
